import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Button, ButtonToolbar, PanelGroup} from 'react-bootstrap'
import i18n from '../i18n'
import CreateOpeningTicketInstructionPanel from './CreateOpeningTicketInstructionPanel'
import UpdateOpeningTicketInstructionPanel from './UpdateOpeningTicketInstructionPanel'
import AssociateDissociateOpeningTicketPurposeFromInstructionModal from './AssociateDissociateOpeningTicketPurposeFromInstructionModal'
import style from './OpeningTicketInstructionPanelGroup.less'

function modalName(result) {
    switch (result) {
        case 'AssociateDissociateOpeningTicketPurposeFromInstruction':
            return 'AssociateDissociateOpeningTicketPurposeFromInstructionModal'
        default:
            return null
    }
}

class OpeningTicketInstructionPanelGroup extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.stream != this.props.stream) {
            const {stream} = nextProps
            const {activeOpeningTicketInstruction} = this.state
            
            const nextActiveOpeningTicketInstruction = activeOpeningTicketInstruction && stream.find((i) => i.uid == activeOpeningTicketInstruction.uid)
            this.setState({activeOpeningTicketInstruction: nextActiveOpeningTicketInstruction})
        }
    }

    _openPanel(key) {
        const {activeKey} = this.state

        const nextActiveKey = activeKey != key && key || null
        this.setState({activeKey: nextActiveKey})
    }

    _openModal(event, result, activeOpeningTicketInstruction) {
        event.preventDefault()

        const openedModal = modalName(result)
        this.setState({openedModal, activeOpeningTicketInstruction})
    }

    _closeModal(event) {
        if (event) {
            event.preventDefault()
        }

        this.setState({openedModal: null})
    }

    render() {
        const {dispatch, stream} = this.props
        const {openedModal, activeOpeningTicketInstruction, activeKey} = this.state

        return (
            <div>
                <Row>
                    <Col sm={8}>
                        <PanelGroup accordion
                            activeKey={activeKey}
                            onSelect={(k) => this._openPanel(k)}>
                            {stream.map((openingTicketInstruction) => (
                                <UpdateOpeningTicketInstructionPanel
                                    key={openingTicketInstruction.uid}
                                    eventKey={openingTicketInstruction.uid}
                                    openingTicketInstruction={openingTicketInstruction}
                                    onSubmit={(e, r, m) => this._openModal(e, r, m)} />
                            ))}
                            {activeKey == 'new' && (
                                <CreateOpeningTicketInstructionPanel
                                    eventKey='new' />
                            )}
                        </PanelGroup>
                        {activeKey != 'new' && (
                            <ButtonToolbar>
                                <Button
                                    bsStyle='primary'
                                    bsSize='large'
                                    onClick={() => this._openPanel('new')}>
                                    {i18n.newOpeningTicketInstruction}
                                </Button>
                            </ButtonToolbar>
                        )}
                    </Col>
                    <Col sm={4}>
                        <div className={style.side}>
                            <h4>{stream.length} {i18n.openingTicketInstructions}</h4>
                        </div>
                    </Col>
                </Row>
                {activeOpeningTicketInstruction && (
                    <AssociateDissociateOpeningTicketPurposeFromInstructionModal
                        show={openedModal == 'AssociateDissociateOpeningTicketPurposeFromInstructionModal'}
                        onHide={(e) => this._closeModal(e)}
                        openingTicketInstruction={activeOpeningTicketInstruction} />
                )}
            </div>
        )
    }
}

OpeningTicketInstructionPanelGroup = connect((state) => ({
    stream: state.message.openingTicketInstruction.stream
}))(OpeningTicketInstructionPanelGroup)

export default OpeningTicketInstructionPanelGroup


// WEBPACK FOOTER //
// ./lib/message/components/OpeningTicketInstructionPanelGroup.js